import React, { useState } from 'react';
import { CoherencePanel, CoherencePanelSize } from '@coherence-design-system/controls';
import { useForm } from 'react-hook-form';
import { CoherencePanelStyles } from '../../../app/common/styles/CommonStyleObjects';
import ActionButtons from '../../common/ActionButtons';
import TerminationIntakeRequestForm from './TerminationIntakeRequestForm';

interface ITerminationIntakeRequestPanelProps {
  closePanel: () => void;
}

const TerminationIntakeRequestPanel = ({
  closePanel,
}: ITerminationIntakeRequestPanelProps): JSX.Element => {
  const intakeForm = useForm();
  const { handleSubmit } = intakeForm;
  const [uploadInProgress, setUploadInProgress] = useState(false);

  const handleSubmitClick = (): void => {
    // TODO: Persist the termination intake request once the backend mutation is available in future user story.
  };

  return (
    <CoherencePanel
      panelSize={CoherencePanelSize.medium}
      titleText="Termination Intake Request"
      isOpen
      onDismiss={closePanel}
      styles={CoherencePanelStyles}
      hasCloseButton
      closeButtonAriaLabel="Close Termination Intake Request Panel"
      onRenderFooter={(): JSX.Element => (
        <ActionButtons
          mutationLoading={uploadInProgress}
          closePanel={closePanel}
          saveLabel="Submit"
          saveTitle="Submit"
          cancelLabel="Cancel"
          cancelTitle="Cancel"
          handleSubmit={handleSubmit(handleSubmitClick)}
        />
      )}
    >
      <form>
        <TerminationIntakeRequestForm form={intakeForm} setUploadInProgress={setUploadInProgress} />
      </form>
    </CoherencePanel>
  );
};

export default TerminationIntakeRequestPanel;
